import $ from 'jquery'

import colors from '../../../../../lib/colors'

export default function(o,p){

  var set = function(text){
    div.html(text)
  }

  var div =
    $('<div>')
    .css({
      position: 'absolute',
      height: '34px',
      bottom: 0,
      left: 0,
      right: 0,
      padding: '8px',
      color: colors.white,
      background: colors.grey.s_900,
      borderTop: `1px solid ${colors.grey.s_800}`,
    })

  div.set = set

  return div;

}



// WEBPACK FOOTER //
// ./src/client/view/admin/search/table/footer/footer.js